;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import {
  formatDate,
  parseDateString,
  readApiNotificationKey,
  readApiNotificationSubcategory,
} from '@workspace/ui/lib';
import {
  DEFAULT_NOTIFICATION_TYPE,
  type NotificationApiResponse,
  type NotificationItem,
  type NotificationType,
} from '@/types/notifications';

export { getPayrollToRunNotificationHref } from '@workspace/ui/lib';

/** BE returns `created_at` as `dd/MM/yyyy HH:mm:ss` (e.g. `22/04/2026 13:10:13`). */
function parseNotificationCreatedAt(createdAt: string): Date | undefined {
  const s = createdAt.trim();
  if (!s) return undefined;
  return parseDateString(s, 'dd/MM/yyyy HH:mm:ss');
}

export function mapApiNotificationToItem(
  apiNotification: NotificationApiResponse
): NotificationItem {
  const isRead = apiNotification.is_read ?? false;

  const notificationType: NotificationType = (apiNotification.category?.value ||
    apiNotification.type?.value ||
    DEFAULT_NOTIFICATION_TYPE) as NotificationType;

  // Format date — BE can sometimes return an invalid/empty timestamp; never throw from mapping.
  const createdAt = apiNotification.created_at;
  let date = '';
  if (createdAt) {
    const parsed = parseNotificationCreatedAt(createdAt);
    if (parsed) {
      date = formatDate(parsed, 'MMM dd, yyyy');
    }
  }

  return {
    id: apiNotification.id,
    notification_user_id: apiNotification.notification_user_id,
    type: notificationType,
    key: readApiNotificationKey(apiNotification),
    subcategory: readApiNotificationSubcategory(apiNotification),
    metadata: apiNotification.metadata ?? null,
    message: apiNotification.body || '',
    date,
    read: isRead,
  };
}
